import { render } from "./LoginFormTitle.vue?vue&type=template&id=503cecb4"
import script from "./LoginFormTitle.vue?vue&type=script&lang=js"
export * from "./LoginFormTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__